import { render, staticRenderFns } from "./bindDevice.vue?vue&type=template&id=556a056a&scoped=true"
import script from "./bindDevice.vue?vue&type=script&lang=js"
export * from "./bindDevice.vue?vue&type=script&lang=js"
import style0 from "./bindDevice.vue?vue&type=style&index=0&id=556a056a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a056a",
  null
  
)

export default component.exports